<script>
import options from "./QuickOrder.options";
export default options;
</script>

<template>
  <h2>{{ getLabel('quickOrderTitle') }}</h2>
  <article class="nlx-quick-order">
    <div class="nlx-quick-order__variant-sku">
      <label class="nlx-quick-order__label" for="variantSku">{{getLabel('quickOrderVariantSku')}}</label>
      <input class="nlx-quick-order__inputfield" v-bind:class="{failed : !addSuccess}" id="variantSku" type="number" v-model="variantSku" @keyup.enter="addToCart" />
    </div>
    <div class="nlx-quick-order__quantity">
      <label class="nlx-quick-order__label" for="quantity">{{getLabel('quickOrderQuantity')}}</label>
      <input class="nlx-quick-order__inputfield" id="quantity" type="number" v-model="amount" @keyup.enter="addToCart" />
    </div>
    <button class="nlx-quick-order__add-to-cart" @click="addToCart" :disabled="disableButton === true || addToCartDisabled">
      {{getLabel('quickOrderAddToCart')}}
    </button>
    <p v-if="addToCartDisabled" class="nlx-quick-order__disabled-message">{{ addToCartDisabledMessage }}</p>
  </article>
</template>
